module.exports = __webpack_public_path__ + "static/media/shapes_14.d74e0f65.svg";